export class ImageRequest {
  code: string;
  chainCode: string;
}